<script>
    import store from '../../../script/store/checkout';
    import { readUrlQuery } from '../../../script/common';
    import { cartService } from '../../../service/resource';
    import { CHECKOUT_STEPS } from '../../../script/store/checkout/consts';
    import PaymentBoleto from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentBoleto.vue';
    import PaymentCredit from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentCredit';
    import PaymentLink from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentLink';
    import PaymentMasterpass from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentMasterpass';
    import PaymentPaypal from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentPaypal';
    import PaymentPix from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentPix';
    import PaymentTransfer from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentTransfer';
    import PaymentVisaCheckout from '../../../../../submodules/src/componentsV2/checkout/common/payment/CheckoutPaymentVisaCheckout';
    export default {
        name: 'BaseCheckoutPayment',

        components: {
            PaymentTransfer,
            PaymentBoleto,
            PaymentPix,
            PaymentVisaCheckout,
            PaymentMasterpass,
            PaymentPaypal,
            PaymentCredit,
            PaymentLink,
        },

        data() {
            return {
                ...CHECKOUT_STEPS,

                storeState: store.state,

                loading: false,

                paymentMethods: null,

                componentsMap: {
                    boleto_bancario: 'PaymentBoleto',
                    pix: 'PaymentPix',
                    cartoesdecredito: 'PaymentCredit',
                    paypal: 'PaymentPaypal',
                    masterpass: 'PaymentMasterpass',
                    visa_checkout: 'PaymentVisaCheckout',
                    transfer: 'PaymentTransfer',
                    payment_link: 'PaymentLink',
                },

                alert: null,
            };
        },

        watch: {
            activeStep: {
                immediate: true,
                handler(to) {
                    if (to === this.STEP_PAYMENT) {
                        if (this.cart.total_paid <= 0) {
                            this.$emit('allow-checkout');
                            this.paymentMethods = null;
                        } else {
                            this.fetchPaymentMethods();
                        }
                    }
                },
            },

            paymentMethods(to) {
                if (
                    !to ||
                    (this.storeState.payment.selectedMethod &&
                        !to[this.storeState.payment.selectedMethod.module])
                ) {
                    this.selectMethod(null);
                }
            },

            cart: {
                immediate: true,
                handler(to) {
                    if (to && to.total_paid <= 0) {
                        this.selectMethod({
                            module: 'gratis',
                        });
                        this.storeState.payment.payloadBuilder = (callback) =>
                            callback({
                                module: 'gratis',
                                installments: 1,
                            });
                    }
                },
            },
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            activeStep() {
                return this.storeState.step.active;
            },

            customer() {
                return (this.cart.customer || {}).data;
            },

            fastLoginEmail() {
                return this.storeState.authentication.fastLoginEmail;
            },

            paymentMethodsList() {
                if (!this.paymentMethods) return null;

                const paymentMethodsList = [];

                if (this.paymentMethods.cartoesdecredito) {
                    paymentMethodsList.push({
                        label: this.$t('_shop.creditCard'),
                        module: 'cartoesdecredito',
                    });
                }

                if (this.paymentMethods.pix) {
                    paymentMethodsList.push({
                        label: 'Pix',
                        module: 'pix',
                    });
                }

                if (this.paymentMethods.boleto_bancario) {
                    paymentMethodsList.push({
                        label: this.$t('_shop.bankBillet'),
                        module: 'boleto_bancario',
                    });
                }

                if (this.paymentMethods.transfer) {
                    paymentMethodsList.push({
                        label: this.$t('_shop.bankDeposit'),
                        module: 'transfer',
                    });
                }

                if (this.paymentMethods.paypal) {
                    paymentMethodsList.push({
                        label: 'PayPal',
                        module: 'paypal',
                    });
                }

                if (this.paymentMethods.visa_checkout) {
                    paymentMethodsList.push({
                        label: 'Visa Checkout',
                        module: 'visa_checkout',
                    });
                }

                if (this.paymentMethods.masterpass) {
                    paymentMethodsList.push({
                        label: 'Masterpass',
                        module: 'masterpass',
                    });
                }

                if (this.paymentMethods.payment_link) {
                    paymentMethodsList.push({
                        label: this.$t('_shop.paymentLink'),
                        module: 'payment_link',
                    });
                }

                return paymentMethodsList;
            },
        },

        methods: {
            fetchPaymentMethods() {
                this.loading = true;
                cartService
                    .paymentMethods(
                        this.cart.id,
                        {},
                        {
                            headers: {
                                'cr-api-fast-auth': this.fastLoginEmail,
                            },
                        }
                    )
                    .then((response) => {
                        this.paymentMethods = response.data;
                        this.verifyMasterpassToken();
                    })
                    .catch((error) =>
                        this.showError(
                            error.response && error.response.data
                                ? error.response.data.message
                                : this.$t('_checkout._payment.errorLoadMethodsTryAgain')
                        )
                    )
                    .then(() => (this.loading = false));
            },

            verifyMasterpassToken() {
                const oauthToken = readUrlQuery('oauth_token');

                if (
                    !this.storeState.payment.selectedMethod &&
                    oauthToken &&
                    oauthToken.trim().length > 0
                ) {
                    this.selectMethod(
                        this.paymentMethodsList.find((m) => m.module === 'masterpass')
                    );
                }
            },

            showError(error) {
                this.alert = {
                    message: error,
                    isError: true,
                    timeout: 30000,
                };
            },

            selectMethod(method) {
                store.payment.select(method);
                if (method) {
                    window.dataLayer.push({
                        event: 'add_payment_info',
                        payment_type: method.label,
                    });
                }
            },
        },
    };
</script>
